export const FAVORITE_INTEREST_SELECTOR_ITEMS =
  'FAVORITE_INTEREST_SELECTOR_ITEMS';

export function bulkAddInterestSelectorItems(guideIds) {
  const stringifiedGuideIds = `[${guideIds.toString()}]`;
  return {
    type: FAVORITE_INTEREST_SELECTOR_ITEMS,
    api: {
      endpoint: ['favorites', 'bulkAddInterests'],
      args: [stringifiedGuideIds],
    },
  };
}
